import { render, staticRenderFns } from "./PolicyTable.vue?vue&type=template&id=2016621e&scoped=true&"
import script from "./PolicyTable.vue?vue&type=script&lang=js&"
export * from "./PolicyTable.vue?vue&type=script&lang=js&"
import style0 from "./PolicyTable.vue?vue&type=style&index=0&id=2016621e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016621e",
  null
  
)

export default component.exports